export interface RumProxyOptions {
  path: string;
  parameters: string;
}

/** Bare hostname from DD_RUM_PROXY_HOST; empty string when it isn't configured. */
export const normalizeRumProxyHost = (host?: string): string =>
  (host ?? '')
    .trim()
    .replace(/^https?:\/\//, '')
    .replace(/\/+$/, '');

/**
 * Datadog RUM `proxy` option that sends intake requests to our own host
 * (e.g. edge.chalktalk.com) instead of Datadog's domain, which some school
 * device filters block. Returns undefined when no host is configured, so the
 * SDK keeps sending straight to Datadog.
 */
export const buildRumProxy = (host?: string): ((options: RumProxyOptions) => string) | undefined => {
  const normalizedHost = normalizeRumProxyHost(host);
  if (!normalizedHost) {
    return undefined;
  }
  return ({ path, parameters }) => `https://${normalizedHost}${path}?${parameters}`;
};
